import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User, UserOrg, AccessRequest, UserOrgRole } from "./user.model";
import { Configuration } from "./configuration.model";

@Injectable()
export class AppService {
  private userProfile: User;
  private configuration: Promise<Configuration>;

  constructor(private http: HttpClient) {}

  getConfiguration() {
    if (!this.configuration) {
      this.configuration = this.http
        .get("/configuration")
        .toPromise()
        .then(v => {
          return new Configuration(v);
        });
    }
    return this.configuration;
  }

  getAuthenticationEntryPoint(): Promise<string> {
    return this.getConfiguration().then(config => {
      const enabled = config.success.enabled;
      const entryPoint = config.success.authenticationEntryPoint;
      return enabled ? entryPoint : "/auth/salesforce";
    });
  }

  private buildRole(response): UserOrgRole {
    const role = new UserOrgRole();
    role.prodName = response.prodName;
    role.roleName = response.roleName;
    role.statusCode = response.statusCode;
    return role;
  }

  private buildAccessRequest(response): AccessRequest {
    const request = new AccessRequest();
    request.accReqId = response.accReqId;
    request.productDescription = response.productDescription;
    request.productDisplayName = response.productDisplayName;
    request.productName = response.productName;
    request.requestedDate = response.requestedDate;
    request.roleAdminType = response.roleAdminType;
    request.roleName = response.roleName;
    request.statusCode = response.statusCode;
    return request;
  }

  getUserProfile(): Promise<User> {
    if (this.userProfile) {
      return Promise.resolve(this.userProfile);
    }
    const promise = this.http.get("/api/User/getUserProfile").toPromise();
    return promise.then((value: any) => {
      const user = new User();
      user.familyName = value.user.familyName;
      user.givenName = value.user.givenName;
      user.loggedInUser = value.user.loggedInUser;
      user.role = value.user.role;
      user.uid = value.user.uid;
      user.userName = value.user.userName;
      user.userType = value.user.userType;
      user.organizations = new Array<UserOrg>();
      for (const responseOrg of value.userOrgs) {
        const org = new UserOrg();
        org.cityName = responseOrg.cityName;
        org.country = responseOrg.country;
        org.email = responseOrg.email;
        org.mdmId = responseOrg.mdmId;
        org.orgId = responseOrg.orgId;
        org.orgName = responseOrg.orgName;
        org.stateCode = responseOrg.stateCode;
        org.statusCode = responseOrg.statusCode;
        org.publicCode = responseOrg.publicCode;
        org.accessReqDto = new Array<AccessRequest>();
        for (const responseReq of responseOrg.accessReqDto) {
          org.accessReqDto.push(this.buildAccessRequest(responseReq));
        }
        org.userOrgRoles = new Array<UserOrgRole>();
        for (const responseRole of responseOrg.userOrgRoles) {
          org.userOrgRoles.push(this.buildRole(responseRole));
        }
        user.organizations.push(org);
      }
      this.userProfile = user;
      return user;
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/app.service.ts